/* eslint-disable no-case-declarations */
/* eslint-disable no-undef */
import { ActionTypes } from '../actions';

const INITIAL_STATE = {
  selected: 'Off',
};

const BeelineReducer = (state = INITIAL_STATE, action) => { // changes state value by 1
  switch (action.type) {
    case ActionTypes.SELECT_THEME:
      const { newSelected } = action.payload;
      return { ...state, selected: newSelected };
    case ActionTypes.BEELINE_TEXT:
      const elements = document.querySelectorAll('.color');
      if (elements !== undefined) {
        elements.forEach((element) => {
          const beeline = new BeeLineReader(element, { theme: state.selected.toLowerCase(), skipBackgroundColor: true });
          if (state.selected !== 'Off') {
            beeline.color();
          } else {
            beeline.uncolor();
          }
        });
      }
      return state;
    case ActionTypes.TURN_OFF_BEELINE:
      return { ...state, selected: 'Off' };
    default:
      return state;
  }
};

export default BeelineReducer;
